// Phase 44.22 — Card "Invia il link al destinatario" inline nella schermata ordine.
//
// Richiesto dall'utente: stessa UI della card profilo ma DENTRO la pagina ordine
// (cliente + driver). Sostituisce i piccoli pulsanti "Condividi tracking" /
// "Invia link" sparsi in precedenza con una card visibile e immediata.
//
// Props:
//   - orderId: required
//   - readOnly: bool — true per driver (vede solo link già attivi del cliente)
//   - testid: override del data-testid (default: order-share-tracking-card)

import { useState } from "react";
import { Share2 } from "lucide-react";
import ShareTrackingModal from "@/components/ShareTrackingModal";

export default function OrderShareTrackingCard({ orderId, readOnly = false, testid = "order-share-tracking-card" }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="card-soft p-5 sm:p-6" data-testid={testid}>
      <div className="flex items-start gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-dapnow-blue-soft text-dapnow-blue shrink-0">
          <Share2 className="h-5 w-5" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="overline">Condividi tracking</p>
          <p className="font-display text-lg font-bold tracking-tight mt-0.5">Invia il link al destinatario</p>
          <p className="text-xs text-dapnow-muted mt-1 leading-relaxed">
            {readOnly
              ? "Vedi e copia il link tracking attivo. Solo il cliente può generarlo o revocarlo."
              : "Genera un link pubblico sicuro: il destinatario vedrà ETA, mappa live e stato consegna senza accedere all'app."}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`${testid}-open-btn`}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-dapnow-ink text-white font-semibold tracking-tight hover:bg-dapnow-ink/90 transition active:scale-[0.99]"
      >
        <Share2 className="h-4 w-4" />
        {readOnly ? "Apri tracking condivisibile" : "Invia link al destinatario"}
      </button>

      {open && (
        <ShareTrackingModal
          orderId={orderId}
          open={open}
          onClose={() => setOpen(false)}
          readOnly={readOnly}
        />
      )}
    </div>
  );
}
